import colors from "PFTheme/tokens/colors";

type UseBackgroundColor = {
  availableMinutes: number;
  nominalWorkingMinutes: number;
};

export const useBackgroundColor = ({
  availableMinutes,
  nominalWorkingMinutes
}: UseBackgroundColor): string => {
  if (nominalWorkingMinutes === 0 && availableMinutes === 0) {
    return colors.paletteWhite3;
  }
  if (availableMinutes === 0) {
    return colors.paletteGreen2;
  }
  if (availableMinutes > 0) {
    return colors.paletteRed2;
  }
  return colors.paletteOrange2;
};
